import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from '../shareModule/services/auth-service.service';
import { ApiResponse } from '../shareModule/models/common.model';
import { CustomerService } from '../shareModule/services/customer.service';

@Component({
  selector: 'app-edit-category',
  templateUrl: './edit-category.component.html',
  styleUrls: ['./edit-category.component.scss'],
})
export class EditCategoryComponent {
  constructor(
    public modal: NgbActiveModal,
    private cdr: ChangeDetectorRef,
    private toastr: ToastrService,
    private auth: AuthServiceService,
    private customerService: CustomerService
  ) { }

  // ─────────── Private fields ───────────
  private _isSubCat = false;
  private _isSubregionCombination = false;
  private _imageBase64: string | ArrayBuffer | null = null;
  private _imageBase64Banner: string | ArrayBuffer | null = null;
  private _subCategory: any = null;
  private _currentType: any = null;
  private _categoryName = '';
  private _categoryImage: string | File = '';
  private _categoryBannerImage: string | File = '';
  private _categoryTitle = '';
  private _categoryContent = '';
  private _categoryMeta = '{}';
  private _codeSchema = '';
  private _bottomText = '';
  private _currentBottomText = '';
  private _selMenu = 'sub-category';
  private _formMenu = 'main';
  private _promoRedirectURL = '';
  private _selectedPromoFile: File | null = null;
  private _encodedPromoFile: ArrayBuffer | string | null = null;
  private _categoryEditMode = '';
  private _subRegionSlug = '';
  private _domMeta = ''; // ✅ new field added


  // ─────────── Inputs (Getters/Setters with detectChanges) ───────────
  @Input() set isSubregionCombination(v: boolean) { this._isSubregionCombination = v; this.cdr.detectChanges(); }
  get isSubregionCombination() { return this._isSubregionCombination; }

  @Input() set imageBase64(v: string | ArrayBuffer | null) { this._imageBase64 = v; this.cdr.detectChanges(); }
  get imageBase64() { return this._imageBase64; }

  @Input() set imageBase64Banner(v: string | ArrayBuffer | null) { this._imageBase64Banner = v; this.cdr.detectChanges(); }
  get imageBase64Banner() { return this._imageBase64Banner; }

  @Input() set subCategory(v: any) { this._subCategory = v; this.cdr.detectChanges(); }
  get subCategory() { return this._subCategory; }

  @Input() set currentType(v: any) { this._currentType = v; this.cdr.detectChanges(); }
  get currentType() { return this._currentType; }

  @Input() set categoryName(v: string) { this._categoryName = v; this.cdr.detectChanges(); }
  get categoryName() { return this._categoryName; }

  @Input() set categoryImage(v: string | File) { this._categoryImage = v; this.cdr.detectChanges(); }
  get categoryImage() { return this._categoryImage; }

  @Input() set categoryBannerImage(v: string | File) { this._categoryBannerImage = v; this.cdr.detectChanges(); }
  get categoryBannerImage() { return this._categoryBannerImage; }

  @Input() set categoryTitle(v: string) { this._categoryTitle = v; this.cdr.detectChanges(); }
  get categoryTitle() { return this._categoryTitle; }

  @Input() set categoryContent(v: string) { this._categoryContent = v; this.cdr.detectChanges(); }
  get categoryContent() { return this._categoryContent; }

  @Input() set categoryMeta(v: string) { this._categoryMeta = v; this.cdr.detectChanges(); }
  get categoryMeta() { return this._categoryMeta; }

  @Input() set codeSchema(v: string) { this._codeSchema = v; this.cdr.detectChanges(); }
  get codeSchema() { return this._codeSchema; }

  @Input() set bottomText(v: string) { this._bottomText = v; this.cdr.detectChanges(); }
  get bottomText() { return this._bottomText; }

  @Input() set currentBottomText(v: string) { this._currentBottomText = v; this.cdr.detectChanges(); }
  get currentBottomText() { return this._currentBottomText; }

  @Input() set selMenu(v: string) { this._selMenu = v; this.cdr.detectChanges(); }
  get selMenu() { return this._selMenu; }

  @Input() set formMenu(v: string) { this._formMenu = v; this.cdr.detectChanges(); }
  get formMenu() { return this._formMenu; }

  @Input() set promoRedirectURL(v: string) { this._promoRedirectURL = v; this.cdr.detectChanges(); }
  get promoRedirectURL() { return this._promoRedirectURL; }

  @Input() set selectedPromoFile(v: File | null) { this._selectedPromoFile = v; this.cdr.detectChanges(); }
  get selectedPromoFile() { return this._selectedPromoFile; }

  @Input() set encodedPromoFile(v: ArrayBuffer | string | null) { this._encodedPromoFile = v; this.cdr.detectChanges(); }
  get encodedPromoFile() { return this._encodedPromoFile; }

  @Input() set categoryEditMode(v: string) { this._categoryEditMode = v; this.cdr.detectChanges(); }
  get categoryEditMode() { return this._categoryEditMode; }

  @Input() set subRegionSlug(v: string) { this._subRegionSlug = v; this.cdr.detectChanges(); }
  get subRegionSlug() { return this._subRegionSlug; }

  @Input() set domMeta(v: string) { this._domMeta = v; this.cdr.detectChanges(); } // ✅ new Input with detectChanges
  get domMeta() { return this._domMeta; }


  get filter() {
    if (this._currentType?.id) {
      return 'type';
    } else if (this._categoryEditMode || this._subRegionSlug) {
      return 'sub-category';
    } else {
      return 'category';
    }
  }

  get filterId() {
    if (this._currentType?.id) {
      return this._currentType?.id;
    } else if (this._categoryEditMode || this._subRegionSlug) {
      return this._categoryEditMode || this._subRegionSlug;
    } else {
      return this._subCategory?.id;
    }
  }

  public domSchema: string = '';



  public get categoryId(){
    return this.subCategory?.categorieChildId || this.subCategory?.id
  }

  @Input() set isSubCat(v: boolean) {
    this._isSubCat = v;
    if (this._isSubCat) {
      console.log('category is a subcat')
      this.auth.getCategoryFAQInfo(this.subCategory?.categorieChildId).subscribe({
        next: data => {
          this.subCategory = data.body;
          console.log('subcat data is', this.subCategory)
        }
      })

    }

    this.cdr.detectChanges();
  }
  get isSubCat() { return this._isSubCat; }

  // ─────────── Private Methods ───────────

  private _getCombinationInfos(customSlug: string | null = null): void {
    const slug = customSlug || this._subRegionSlug;

    this.auth
      .getMetaInSubCategiryAndSubregionCombinationInfo(
        slug,
        this._subCategory?.id,
        '1',
        this._currentType?.id
      )
      .subscribe({
        next: (data) => {
          try {
            const body = data.body || {};
            this._subCategory.faqInfos = body.faqInfos ?? '{}';
            this._categoryMeta = body.categoryMeta ?? '{}';
            this._codeSchema = body.codeSchema ?? '';
            this._bottomText = body.bottomText ?? '';
            this._currentBottomText = this._bottomText;
            this._categoryImage = body.categoryImage ?? '';
            this._domMeta = body.domMeta ?? ''; // ✅ support new field
            this.cdr.detectChanges();
          } catch (error) {
            console.error(error);
            this.cdr.detectChanges();
          }
        },
        error: (err) => {
          console.error(err);
          this.cdr.detectChanges();
        },
      });
  }

  // ─────────── Public Methods ───────────

  public editCategorySubmit(): void {
    const formData = new FormData();

    if (typeof this._categoryImage !== 'string') {
      formData.append('image', this._categoryImage);
    }
    if (typeof this._categoryBannerImage !== 'string') {
      formData.append('bannerImage', this._categoryBannerImage);
    }

    formData.append('id', this._subCategory?.id);
    formData.append('name', this._categoryName.trim());
    formData.append('promoFile', this._selectedPromoFile ?? '');
    formData.append('promoRedirectURL', this._promoRedirectURL);
    formData.append('content', this._categoryContent);
    formData.append('domMeta', this._domMeta); // ✅ added new field to FormData



    formData.append('metaConfig', this._categoryMeta);
    formData.append('codeSchema', this._codeSchema);
    formData.append('bottomText', this._currentBottomText);

    let subs;

    if (this._isSubregionCombination) {
      formData.append('subCategoryId', this._subCategory?.id);
      formData.append('subRegionId', this._categoryEditMode || this._subRegionSlug);
      formData.append('typeId', this._currentType?.id ?? '');
      subs = this.auth.updateMetaInSubCategoryAndSubregionCombinationInfo(formData, '1');
    } else {
      subs = this.auth.updateMemberCategoryInfo(formData);
    }

    subs.subscribe(
      (resp: ApiResponse) => {
        if (this._isSubregionCombination) {
          this._getCombinationInfos(this._categoryEditMode);
        }
        this.toastr.success(resp.message);
        this.cdr.detectChanges();
      },
      ({ error }) => {
        this.toastr.error(error.message);
        this.cdr.detectChanges();
      }
    );
  }

  public promoBannerChange(event: any): void {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = () => {
      this._selectedPromoFile = file;
      this._encodedPromoFile = reader.result;
      this.cdr.detectChanges();
    };
    reader.readAsDataURL(file);
  }

  public saveProductCharSelectedImage(event: any, isBanner = false): void {
    const file = event.target.files[0];
    if (!file) return;

    if (this._subCategory) {
      this._subCategory[isBanner ? 'bannerImage' : 'image'] = null;
    }

    const fileReader = new FileReader();
    fileReader.onload = () => {
      if (isBanner) {
        this._imageBase64Banner = fileReader.result;
        this._categoryBannerImage = file;
      } else {
        this._imageBase64 = fileReader.result;
        this._categoryImage = file;
      }
      this.cdr.detectChanges();
    };
    fileReader.readAsDataURL(file);
  }
}
